import {connect} from "react-redux"
import {SupportedRegionTypes, SupportedRegionSubTypes} from "../../models/regions"
import {formatCdnPathWithVariant} from "../../utils/getCdnUrl"
import getMyAccountQuicklinks from "../../utils/getMyAccountQuicklinks"
import {State} from "../../ducks"
import configRelativePathURL from "../../utils/configUrlPath"

export const mapStateToProps = (state: State) => {
    const {
        user: {firstName, userUpdated, loggedIn},
        data,
        request: {siteUrl},
        text: {myAccount},
        settings: {iconsVersionPath},
    } = state

    const realm = data?.realm || "next"
    const isLoggedIn = loggedIn

    const quickLinks = data?.regions
        ?.filter(region => region.type === SupportedRegionTypes.BurgerMenu)[0]
        ?.elements?.filter(link => link.type === SupportedRegionSubTypes.MyAccount)[0].elements
    if (!quickLinks) return null

    const myAccountLinks = getMyAccountQuicklinks(quickLinks, isLoggedIn, userUpdated, firstName)
    const {accessibilityText, description, icon, myAccountText, url} = myAccountLinks

    return {
        accessibilityText,
        url: configRelativePathURL(url || "", siteUrl),
        myAccountText,
        firstName,
        userUpdated,
        text: myAccount,
        icon:
            icon !== null && icon !== ""
                ? formatCdnPathWithVariant(icon || "", realm, undefined, iconsVersionPath || "")
                : null,
        description,
        isLoggedIn,
    }
}

export default connect(mapStateToProps)
